(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dmt-hero-banner"] && !Shopify.designMode) return;
  try {
    
    class DmtHeroBanner extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-dmt-track]');
        this.slides = Array.from(this.querySelectorAll('[data-dmt-slide]'));
        if (!this.track || this.slides.length < 2) return;

        this.autoplayDelay = parseInt(this.dataset.autoplay, 10) || 0;
        this.dots = Array.from(this.querySelectorAll('[data-dmt-dot]'));

        this.querySelector('[data-dmt-prev]')?.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
        this.querySelector('[data-dmt-next]')?.addEventListener('click', () => this.goTo(this.currentIndex() + 1));
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.dmtDot, 10)));
        });

        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.updateDots(), 80);
        });

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.autoplayDelay && !reducedMotion && !window.Shopify?.designMode) {
          this.startAutoplay();
          this.addEventListener('pointerenter', () => this.stopAutoplay());
          this.addEventListener('pointerleave', () => this.startAutoplay());
          this.addEventListener('focusin', () => this.stopAutoplay());
          this.addEventListener('focusout', () => this.startAutoplay());
          this.onVisibilityChange = () => {
            if (!this.isConnected) return;
            document.hidden ? this.stopAutoplay() : this.startAutoplay();
          };
          document.addEventListener('visibilitychange', this.onVisibilityChange);
        }

        if (window.Shopify?.designMode) {
          this.onBlockSelect = (event) => {
            const index = this.slides.indexOf(event.target);
            if (index > -1) this.goTo(index);
          };
          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.onVisibilityChange) document.removeEventListener('visibilitychange', this.onVisibilityChange);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      currentIndex() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      goTo(index) {
        const target = (index + this.slides.length) % this.slides.length;
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: 'smooth' });
      }

      updateDots() {
        const current = this.currentIndex();
        this.dots.forEach((dot, i) => {
          if (i === current) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      startAutoplay() {
        if (!this.autoplayDelay) return;
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => this.goTo(this.currentIndex() + 1), this.autoplayDelay);
      }

      stopAutoplay() {
        clearInterval(this.autoplayTimer);
      }
    }

    if (!customElements.get('dmt-hero-banner')) {
      customElements.define('dmt-hero-banner', DmtHeroBanner);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
